/**
 * Created by Administrator on 2018/8/23.
 */
import http from "./iglobal";
import ApiSetting from "./apiSetting";

const httpfn = {http,ApiSetting}

export default httpfn





// WEBPACK FOOTER //
// ./src/api/index.js